import { ITableHeader } from '@base/@types/components/Layout/TableGrid'

const cronPurchaseAlcada: ITableHeader[] = [
  {
    group: 'ID',
    columns: [
      {
        id: 'id-id',
        name: 'ID',
        show: true
      }
    ]
  },
  {
    group: 'Usuário',
    columns: [
      {
        id: 'nome-usuario',
        name: 'Nome do Perfil',
        show: true
      }
    ]
  },
  {
    group: 'Tolerância',
    columns: [
      {
        id: 'tolerancia',
        name: 'Tolerância',
        show: true
      }
    ]
  }
]

export default cronPurchaseAlcada
